import { Grid2 as Grid } from '@mui/material';
import { CurrencyInput, TextInput } from 'framework/form';
import React from 'react';
import BillingRequestFormPeriodicBase from './BillingRequestFormPeriodicBase';

const BillingRequestFormPeriodicPostpaidOrMilestone = ({ isUpdate }: { isUpdate?: boolean }) => {
  return (
    <BillingRequestFormPeriodicBase
      isUpdate={isUpdate}
      commonFieldSize={5}
      renderExtraFields={({ item, index, inApprovalStatus, isPeriodic }) => (
        <>
          <Grid size={3}>
            <CurrencyInput
              label="Actual amount"
              source={`data.${index}.amount`}
              suffix={item.currency || ''}
              isControlledValue
              disabled={inApprovalStatus}
            />
          </Grid>
          {isPeriodic && (
            <Grid size={3}>
              <TextInput source={`data.${index}.hours`} label="Actual hours" disabled={inApprovalStatus} />
            </Grid>
          )}
        </>
      )}
    />
  );
};
export default BillingRequestFormPeriodicPostpaidOrMilestone;
